import request from '@/utils/request'
let resquest = process.env.VUE_APP_BASE_API

export default {
  /* ---------------------------------小说拆分区域---------------------------- */
  
  //分类列表
  categoryList(target,params) {
    return request({
      url: `${resquest}/novel/app/subject/category?target=${target}`,
      method: 'get',
      params
    })
  },
  //分类详情
  categoryDetail(params) {
    return request({
      url: `${resquest}/novel/app/subject/category/details`,
      method: 'get',
      params
    })
  },
  //推荐列表
  subjectList(params) {
    return request({
      url: `${resquest}/novel/app/subject/list`,
      method: 'get',
      params
    })
  },
  //小说详情
  novelDetail(uid,params) {
    return request({
      url: `${resquest}/novel/app/subject/details?uid=${uid}`,
      method: 'get',
      params
    })
  },
  //灵感生成
  subjectInspiration(uid,data,params) {
    return request({
      url: `${resquest}/novel/app/subject/inspiration/v2?uid=${uid}`,
      // headers: {
      //   "Content-Type": 'application/json;charset=utf-8'
      // },
      method: 'post',
      params,
      data
    })
  },
  //灵感记录
  subjectLog(uid,params) {
    return request({
      url: `${resquest}/novel/app/subject/inspiration/log?uid=${uid}`,
      method: 'get',
      params
    })
  },
  //灵感详情
  subjectDetail(id,params) {
    return request({
      url: `${resquest}/novel/app/subject/inspiration/details?id=${id}`,
      method: 'get',
      params
    })
  },
  //删除记录
  delLog(id,data) {
    return request({
      url: `${resquest}/novel/app/subject/inspiration/delete?id=${id}`,
      method: 'post',
      data
    })
  },
  //置顶记录
  top(id,data){
    return request({
      url: `${resquest}/novel/app/subject/inspiration/top?id=${id}`,
      method: 'post',
      data
    })
  },
  //开关
  flag(params){
    return request({
      url: `${resquest}/novel/app/subject/flag`,
      method: 'get',
      params
    })
  },
  //收藏
  openCollect(uid,params){
    return request({
      url: `${resquest}/novel/app/subject/collect?uid=${uid}`,
      method: 'post',
      params
    })
  },
  //取消收藏
  closeCollect(uid,params){
    return request({
       url: `${resquest}/novel/app/subject/uncollect?uid=${uid}`,
      method: 'post',
      params
    })
  },
  //收藏列表
  collectList(params){
    return request({
       url: `${resquest}/novel/app/subject/collects`,
      method: 'get',
      params
    })
  }
}